import { TableCell } from '@tiptap/extension-table-cell'
import type { TResultColorId } from '@team-milva/lab-models/resources'
import { RESULT_COLORS } from '@team-milva/lab-models/resources'

export type TCellVerticalAlign = 'top' | 'middle' | 'bottom'

export const CustomTableCell = TableCell.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      backgroundColor: {
        default: null,
        parseHTML: (element: Element) =>
          (element as HTMLElement).getAttribute('data-background-color') ?? null,
        renderHTML: (attributes: Record<string, unknown>) => {
          const backgroundColor = attributes.backgroundColor as TResultColorId | null
          if (!backgroundColor) return {}
          const colorEntry = Object.values(RESULT_COLORS).find((x) => x.id === backgroundColor)
          if (!colorEntry) return {}
          return {
            'data-background-color': backgroundColor,
            style: `background-color: ${colorEntry.color}; color: ${colorEntry.textColor};`,
          }
        },
      },
      // Left unset (null) for existing/pasted content so it keeps rendering via the
      // report CSS's own default (top) — only freshly inserted tables are given an
      // explicit 'middle' default, set directly in RichTextEditor's insertTable().
      verticalAlign: {
        default: null,
        parseHTML: (element: Element) =>
          (element as HTMLElement).getAttribute('data-vertical-align') ?? null,
        renderHTML: (attributes: Record<string, unknown>) => {
          const verticalAlign = attributes.verticalAlign as TCellVerticalAlign | null
          if (!verticalAlign) return {}
          return {
            'data-vertical-align': verticalAlign,
            style: `vertical-align: ${verticalAlign};`,
          }
        },
      },
    }
  },
})
